export const WELCOME_SEEN_KEY = 'hxd_welcome_seen';

export function hasSeenWelcome() {
  if (typeof window === 'undefined') return false;
  try {
    return window.localStorage.getItem(WELCOME_SEEN_KEY) === '1';
  } catch {
    return false;
  }
}

export function markWelcomeSeen() {
  if (typeof window === 'undefined') return;
  try {
    window.localStorage.setItem(WELCOME_SEEN_KEY, '1');
  } catch {
    /* private browsing / quota — best-effort */
  }
}

export function shouldShowWelcome(pathname, { loading, isAuthenticated }) {
  return (
    pathname === '/' &&
    !loading &&
    !isAuthenticated &&
    !hasSeenWelcome()
  );
}
